module.exports = __webpack_public_path__ + "static/media/activities.88dbb73d.png";